module.exports = __webpack_public_path__ + "img/outCall.a37b3505.svg";